import { ReactNode } from 'react'

import downloadOptionsStyles from '../DownloadOptions.module.css'

export type FieldsetSectionProps = {
	children: ReactNode
	legendIcon: ReactNode
	title: string
}

const FieldsetSection = ({
	children,
	legendIcon,
	title,
}: FieldsetSectionProps): JSX.Element => {
	return (
		<fieldset className={downloadOptionsStyles.fieldset}>
			<legend className={downloadOptionsStyles.srOnly}>{title}</legend>
			<span aria-hidden="true" className={downloadOptionsStyles.legend}>
				{legendIcon}
				{title}
			</span>
			{children}
		</fieldset>
	)
}

export default FieldsetSection
